import { normalizeExtractedDocumentText } from "./text";
import type { DocumentExtraction } from "./types";

export async function extractDocxText(file: File): Promise<DocumentExtraction> {
  const [{ default: mammoth }, arrayBuffer] = await Promise.all([
    import("mammoth/mammoth.browser"),
    file.arrayBuffer(),
  ]);
  const result = await mammoth.extractRawText({ arrayBuffer });
  const errors = result.messages.filter((message) => message.type === "error");
  if (errors.length > 0) {
    throw new Error(errors.map((message) => message.message).join(" "));
  }
  return {
    text: normalizeExtractedDocumentText(result.value),
    warnings: result.messages
      .filter((message) => message.type === "warning")
      .map((message) => message.message),
  };
}
